import React, { useContext, useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, MenuItem, Typography, Grid, Box } from "@mui/material";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { ThemeContext } from "../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import BidValue from '../../components/global/BidAsk/BidValue';
import AskValue from '../../components/global/BidAsk/AskValue';


const CloseByHedgeModal = ({ open, onClose, selectedPosition, closePositionBy_Hedge }) => {
    const positions = useSelector((state) => state.orderPosition.positions);
    const [oppositePositionId, setOppositePositionId] = useState("");
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    // const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const [amount, setAmount] = useState(selectedPosition?.amount)

    useEffect(() => {
        if (selectedPosition) {
            const opposite = positions.find(
                (pos) => pos.symbolId === selectedPosition.symbolId && pos.side !== selectedPosition.side
            );

            if (opposite) {
                setOppositePositionId(opposite.id);
            } else {
                setOppositePositionId("");
                toast.error("No opposite position available for hedging.");
            }
        }
    }, [selectedPosition, positions]);

    const handleCloseByHedge = () => {
        if (!selectedPosition || !oppositePositionId) {
            toast.error("No opposite position available for hedging.");
            return;
        }

        // closePositionBy_Hedge(selectedPosition.id, oppositePositionId, selectedPosition.amount);
        closePositionBy_Hedge(selectedPosition.id, oppositePositionId, Number(amount));

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t('closeByHedge')}</Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={6} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>{t('bid')}</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'center' }}>
                            <BidValue symbolId={selectedPosition?.symbolId} digits={selectedPosition?.digits} />
                        </Box>
                    </Grid>
                    <Grid item xs={6} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>{t('ask')}</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'center' }}>
                            <AskValue symbolId={selectedPosition?.symbolId} digits={selectedPosition?.digits} />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField label="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField select label="Close By Hedge (Opposite Position)" value={oppositePositionId} onChange={(e) => setOppositePositionId(e.target.value)} fullWidth >
                            {positions
                                .filter((pos) => pos.symbolId === selectedPosition?.symbolId && pos.side !== selectedPosition?.side)
                                .map((pos) => (
                                    <MenuItem key={pos.id} value={pos.id}>{pos.id}</MenuItem>
                                ))}
                        </TextField>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Button onClick={onClose} variant="outlined">{t('cancel')}</Button>
                <Button onClick={handleCloseByHedge} color="primary" variant="contained">{t('ClosePosition')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CloseByHedgeModal;
